<template>
  <div class="md:w-1/2 mt-8 px-10">
    <nuxt-link :to="`/contents/${article.slug}`" class="inline-block pb-1 border-secondary border-b">{{direction == 'next' ? '次の記事' : '前の記事'}}</nuxt-link>
    <div class="mt-6">
      <categories :categories="[...article.purposes]" />
    </div>
    <nuxt-link :to="`/contents/${article.slug}`" class="mt-3 flex items-center">
      <div class="thumbnail h-20 w-4/12 mr-4" :style="{'background-image' : `url(${thumbnailURL})`}"></div>
      <div class="w-7/12 text-sm">{{article.title}}</div>
    </nuxt-link>
    <div class="mt-3 flex items-center">
      <div class="text-xs leading-none">{{article.client}}</div>
      <div class="ml-auto text-xs">{{article.publishedAt}}</div>
    </div>
  </div>
</template>
<style lang="sass" scoped>
.thumbnail
  @apply bg-black rounded bg-cover bg-center bg-no-repeat
</style>
<script>
import Categories from '@/components/blog/article/categories';
export default {
  components: {
    Categories
  },
  props: {
    article: { type: Object },
    direction: { type: String }
  },
  computed: {
    thumbnailURL() {
      let path = null
      if (this.article.thumbnail) {
        path = this.article.thumbnail.formats.small ? this.article.thumbnail.formats.small.url : this.article.thumbnail.url
      }
      return path ? this.$options.filters.cmsURL(path) : null;
    }
  }
}
</script>